// extracted by mini-css-extract-plugin
export default {"not_found":"not_found___lGP2X"};